// Legacy route kept only so old links resume into the English-only flow.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding/kid/locale")({
  beforeLoad: () => {
    throw redirect({ to: "/onboarding/kid/pal" });
  },
  component: () => null,
});
